type EventProps = Record<string, string | number | boolean>;
type Track = ((event: string, options?: { props?: EventProps }) => void) & { q?: unknown[][] };

declare global {
  interface Window {
    qwa?: Track;
  }
}

// Records a product event with Quick Web Analytics, loaded from index.html. Events sent
// before the deferred tracker arrives wait in qwa.q, which the tracker replays on load.
// Never throws and never sends names, guesses, scores, or times.
export function trackEvent(event: string, props: EventProps = {}): void {
  try {
    if (typeof window === "undefined") return;
    if (typeof window.qwa !== "function") {
      const queue: Track = (...args) => { (queue.q ??= []).push(args); };
      window.qwa = queue;
    }
    window.qwa(event, { props });
  } catch {
    // Analytics must never interrupt play.
  }
}
